export default __webpack_public_path__ + "static/media/vastaanotto-lightblue.dea39b00.svg";